import ContentCarousel from '@/domains/home/widgets/ContentCarousel';
import { Resource } from '@/types/Content/Resources';
import { observer } from 'mobx-react-lite';
import { Tile } from './Tile';

interface TilesCarouselProps {
  villageId: string;
  arrowColor?: string;
  isSupporterMember: boolean;
  contentList: Array<Resource>;
  defaultSlidesToShow?: number;
}

function TileCarousel({
  villageId,
  arrowColor,
  contentList,
  isSupporterMember,
  defaultSlidesToShow,
}: TilesCarouselProps): JSX.Element {
  const uniqueContentList = [...new Set(contentList)];
  const hasContent = uniqueContentList.length > 0;

  return (
    <ContentCarousel
      arrowColor={arrowColor}
      lengthItem={contentList?.length}
      defaultSlidesToShow={defaultSlidesToShow}
    >
      {hasContent &&
        uniqueContentList.filter((value) => value).map((content) => (
          <Tile
            {...content}
            key={content.id ?? content.contentId}
            villageId={villageId}
            isSupporterMember={isSupporterMember}
          />
        ))}
    </ContentCarousel>
  );
}

TileCarousel.defaultProps = {
  arrowColor: 'black',
  defaultSlidesToShow: 4,
};
export default observer(TileCarousel);
